import State from '@customTypes/state'
import Action from '@customTypes/action'
import Task from '~/types/task'

const saveTasks = (newTasks: Task[]) => {
    localStorage.setItem('tasks', JSON.stringify(newTasks))
}

const tasksReducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'invert_done_value': {
            const newTasks = [...state.tasks].map((task) => {
                if (task.id === action.data.id) {
                    return { ...task, done: !task.done }
                }
                return task
            })

            saveTasks(newTasks)
            return { ...state, tasks: newTasks }
        }

        case 'add_new_task': {
            const newTasks = [...state.tasks, { id: action.data.id, label: action.data.label, done: false }]
            saveTasks(newTasks)
            return { ...state, tasks: newTasks }
        }

        case 'delete_task': {
            const newTasks = [...state.tasks].filter((task) => task.id !== action.data.id)
            saveTasks(newTasks)
            return { ...state, tasks: newTasks }
        }

        case 'reorder_task': {
            const newTasks = [...state.tasks]
            const [target] = newTasks.splice(action.data.sourceIndex, 1)
            newTasks.splice(action.data.destinationIndex, 0, target)
            saveTasks(newTasks)
            return { ...state, tasks: newTasks }
        }

        case 'rename_task': {
            const newTasks = [...state.tasks].map((task, i) => {
                if (task.id === action.data.id) {
                    return { ...task, label: action.data.label }
                }
                return task
            })

            saveTasks(newTasks)
            return { ...state, tasks: newTasks }
        }

        default:
            return { ...state }
    }
}

export default tasksReducer
